import { getStatusRenderComponent } from "./getStatusRenderComponent";

export default getStatusRenderComponent;
